import React, { useState } from 'react';
import { toast } from 'sonner';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

export function InstallBanner() {
  const { canInstall, promptInstall, isIOS, isStandalone } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(
    () => !!localStorage.getItem('auralis_install_dismissed')
  );

  const visible = !isStandalone && !dismissed && (canInstall || isIOS);

  const authRoute = typeof window !== 'undefined' && /^\/(login|onboarding)?$/.test(window.location.pathname);

  const dismiss = () => {
    localStorage.setItem('auralis_install_dismissed', '1');
    setDismissed(true);
  };

  const install = async () => {
    const outcome = await promptInstall();
    if (outcome === 'accepted') {
      toast.success('Auralis is being added to your home screen');
      dismiss();
    } else if (outcome === 'unavailable') {
      toast.message('Use your browser menu to add Auralis to your home screen');
    }
  };

  if (!visible || authRoute) return null;

  return (
    <div
      data-testid="install-banner"
      className="fixed bottom-20 md:bottom-4 left-1/2 -translate-x-1/2 z-50 w-[min(560px,92vw)] rounded-2xl glass px-4 py-3 flex items-center gap-3 animate-fade-up"
    >
      <div
        className="grid place-items-center rounded-xl shrink-0"
        style={{ width: 40, height: 40, background: 'linear-gradient(135deg,#A855F7,#7C3AED)' }}
      >
        <i className="fa-solid fa-heart text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-sm">Install Auralis</div>
        <div className="text-xs text-[var(--aura-ink-soft)] truncate">
          {isIOS && !canInstall ? 'Tap Share, then "Add to Home Screen"' : 'Add to your home screen for quick access'}
        </div>
      </div>
      {(canInstall || !isIOS) && (
        <button
          data-testid="install-app-btn"
          onClick={install}
          className="text-white text-sm font-semibold rounded-full px-4 py-2 aura-btn-gradient"
        >
          Install
        </button>
      )}
      <button data-testid="install-dismiss-btn" onClick={dismiss} className="text-[var(--aura-ink-soft)] px-2">
        <i className="fa-solid fa-xmark" />
      </button>
    </div>
  );
}
